module.exports = __webpack_public_path__ + "static/media/play.908b9e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.png
// module id = 661
// module chunks = 0